import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CoinProvider } from './context/CoinContext';
import { TCoinsProvider } from './context/TCoinsContext';
import { BookingProvider } from './context/BookingContext';
import { ReviewProvider } from './context/ReviewContext';
import { MarketplaceProvider } from './context/MarketplaceContext';
import { NotificationProvider } from './context/NotificationContext';
import { ChatProvider } from './context/ChatContext';
import { CampaignProvider } from './context/CampaignContext';
import { FeatureConfigProvider } from './context/FeatureConfigContext';
import { ThemeProvider } from './context/ThemeContext';
import { TeamProvider } from './context/TeamContext';
import { TeamConfigProvider } from './context/TeamConfigContext';
import { BedProvider } from './context/BedContext';
import { EquipmentProvider } from './context/EquipmentContext';
import { ShiftProvider } from './context/ShiftContext';
import { ShiftPlanProvider } from './context/ShiftPlanContext';
import { GiftProvider } from './context/GiftContext';
import { GamificationProvider } from './context/GamificationContext';
import './styles/theme.css';
import IncomingCallListener from './components/VideoCall/IncomingCallListener';
import AppContent from './components/Layout/AppContent';
import './i18n/config';
import './App.css';

// Component to hide loading screen
function LoadingScreenHider() {
  useEffect(() => {
    // Hide loading screen when component mounts (React has rendered)
    const hideLoading = () => {
      const loading = document.getElementById('loading');
      if (loading) {
        loading.style.opacity = '0';
        loading.style.transition = 'opacity 0.5s ease-out';
        setTimeout(() => {
          loading.style.display = 'none';
        }, 500);
      }
    };

    // Hide immediately when component mounts
    hideLoading();

    // Fallback: Hide after 2 seconds if still visible
    const fallbackTimeout = setTimeout(() => {
      hideLoading();
    }, 2000);

    return () => {
      clearTimeout(fallbackTimeout);
    };
  }, []);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <FeatureConfigProvider>
          <TeamProvider>
            <TeamConfigProvider>
              <BedProvider>
                <EquipmentProvider>
              <ShiftProvider>
                <ShiftPlanProvider>
                <CoinProvider>
                  <TCoinsProvider>
                    <BookingProvider>
                      <NotificationProvider>
                        <GamificationProvider>
                          <GiftProvider>
                            <ReviewProvider>
                              <MarketplaceProvider>
                                <CampaignProvider>
                                  <ChatProvider>
                                    <Router>
                                      <LoadingScreenHider />
                                      <IncomingCallListener />
                                      <AppContent />
                                    </Router>
                                  </ChatProvider>
                                </CampaignProvider>
                              </MarketplaceProvider>
                            </ReviewProvider>
                          </GiftProvider>
                        </GamificationProvider>
                      </NotificationProvider>
                    </BookingProvider>
                  </TCoinsProvider>
                </CoinProvider>
                </ShiftPlanProvider>
              </ShiftProvider>
            </EquipmentProvider>
              </BedProvider>
            </TeamConfigProvider>
          </TeamProvider>
        </FeatureConfigProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;